// Shared helpers for the sidebar subcomponents.

/**
 * Walk the nav tree and return a flat list of every leaf item (`{ to, ... }`),
 * annotated with `groupKey` / `subgroupKey` so the caller knows the ancestry.
 * Used to resolve pinned paths back into full item objects (icon/label/colour).
 */
export function flattenLeaves(items) {
  const out = [];
  for (const n of items || []) {
    if (!n) continue;
    if (n.type === "link" && n.to) {
      out.push({ ...n, groupKey: null });
    } else if (n.type === "group" && Array.isArray(n.children)) {
      for (const c of n.children) {
        if (c.type === "subgroup" && Array.isArray(c.children)) {
          for (const gc of c.children) {
            if (gc.to) out.push({ ...gc, groupKey: n.key, subgroupKey: c.key });
          }
        } else if (c.to) {
          out.push({ ...c, groupKey: n.key });
        }
      }
    }
  }
  return out;
}


/** Slugify a label into the test-id fragment we've always used. */
export function labelSlug(label) {
  return (label || "").toLowerCase().replace(/[^a-z0-9]+/g, "-");
}
